module.exports = __webpack_public_path__ + "img/careplan.fdb3a73.svg";